import { VideoFilter } from "./models/VideoFilter";
import VideoFilterEvents from "./VideoFilterEvents";

export const resetfilter = (videoFilters: VideoFilter) => ({
    type: VideoFilterEvents.resetfilter,
    videoFilters
} as const);
